export enum ReadjustmentType{
    VALUE = 'VALUE',
    VALUEDISCOUNT = 'VALUEDISCOUNT'
}